import { AIStatusColors, DEFAULT_STATUS_MESSAGE } from './ai.constants';
import { IAIState } from './ai.props';

const initialState: IAIState = {
  isAIAutoMode: true, // Indicates whether AI order has been going smoothly or intercepted
  isAIEscalation: false,
  isAIEscalatedOnCarEnter: false, // Triggered AI escalation for faster adoption of brand menu
  requiresTakeover: false, // true only for halting escalations the agent must take over now
  aiStatus: {
    status: AIStatusColors.green,
    message: DEFAULT_STATUS_MESSAGE,
  },
  aiEscalationReason: '',
};

/**
 * Whether an escalation needs an immediate human takeover (AI halted) vs. a
 * recoverable one the AI keeps ordering through. Driven by the backend's
 * structured `ai_requested_hitl_takeover` flag on the escalation. Centralised
 * as the single source of truth for what counts as a takeover.
 */
const escalationRequiresTakeover = (source?: {
  ai_requested_hitl_takeover?: boolean;
}): boolean => !!source?.ai_requested_hitl_takeover;

export { initialState, escalationRequiresTakeover };
